import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { NotifyService } from '../../services/notify.service';
import { timestampFormat } from '../../../config/moment';
import { filterRecentNotifications } from '../../../config/moment';

@Component({
  selector: 'app-notifications-dropdown',
  templateUrl: './notifications-dropdown.component.html',
  styleUrls: ['./notifications-dropdown.component.scss']
})
export class NotificationsDropdownComponent implements OnInit {
  @Input() isOpen: boolean = false;
  @Output() toggleDropdown = new EventEmitter<void>();

  public notify: any = [];
  public timestampFormat = timestampFormat;
  public filterRecentNotifications = filterRecentNotifications;
  public unreadCount: number = 0;

  constructor(
    private notifyService: NotifyService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadNotifications();
  }

  loadNotifications() {
    this.notifyService.getnotify().subscribe((res) => {
      if (res.data) {
        this.notify = this.filterRecentNotifications(res.data.data).slice(0, 5); // Show only latest 5
        this.updateUnreadCount();
      }
    });
  }

  updateUnreadCount() {
    this.unreadCount = this.notify.length;
  }

  onToggleDropdown(event: Event) {
    event.stopPropagation();
    this.toggleDropdown.emit();
  }

  navigateToNotifyList(event: Event) {
    event.stopPropagation();
    this.router.navigate(['/home/notify/list']);
    this.onToggleDropdown(event);
  }
} 